export default __webpack_public_path__ + "6b7cc142cc91496e220f64ceda9e565d.png";